




































import { Component, Prop } from 'vue-property-decorator';
import { QuestionnaireModel } from '@/core/models';
import { QuestionnaireService } from '@/core/services';
import { ConfirmDialogCpt } from '@/core/components';
import AppVue from '@/AppVue.vue';
import moment from 'moment';

@Component({
  components: {
    ConfirmDialogCpt,
  },
})
export default class CheckOutAlertCpt extends AppVue {
  @Prop() model: QuestionnaireModel;

  loading = false;
  showCheckOutConfirm = false;

  get alertTitle() {
    const checkedOutDate = moment(this.model.checkedOutDate).format('dddd, DD MMM YYYY HH:mm');

    return `Questionnaire already checked out by ${this.model.checkedOutByName} on ${checkedOutDate}`;
  }

  private async checkOut() {
    this.showCheckOutConfirm = true;
  }

  private async closeConfirm(result: boolean) {
    this.showCheckOutConfirm = false;
    this.loading = true;
    try {
      if (result === true) {
        await QuestionnaireService.checkOut(this.model.id);
        this.notify('Success', 'Questionnaire successfully checked out', 'success');
        this.$eventHub.$emit('REFRESH_QNR_MODEL');
      }
    } finally {
      this.loading = false;
    }
  }
}
